import { comandosF } from './comandos';
export default function (ticket) {
  const comandos = comandosF(ticket);

  return [comandos.QZ_INIT, comandos.QZ_ABRIR_CAJON];
}
